export default "__VITE_ASSET__CQHPwd34__"